import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProviderModel} from "../../../../models/provider.model";
import {Subscription} from "rxjs";
import {Game, Games} from "../../../../models/game.class";
import {GameService} from "../../../../services/game.service";
import {ActivatedRoute} from "@angular/router";
import {TitleService} from "../../../../services/title.service";
import {TranslateService} from "@ngx-translate/core";
import {Publisher} from "../../../../models/publisher.class";

@Component({
  selector: 'app-selected-category',
  templateUrl: './selected-category.component.html',
  styleUrls: ['./selected-category.component.scss']
})
export class SelectedCategoryComponent implements OnInit, OnDestroy {

  readonly itemsPerPage: number = 24;

  routeSubs?: Subscription;
  chosenCategory?: string | null;

  titleTranslateSubs?: Subscription;

  gameSubs?: Subscription;
  games?: Games;

  randomGamesForCarousel: Game[] = [];

  //TODO refactor categorisation - by tags (they will also be subcategories)

  searchTerm: string = "";

  showProviderSelector = false;
  providersInChosenCategory: Publisher[] = [];
  numOfSelectedProviders: number = 0;
  providerFilter: { [key: string]: boolean } = {};

  selectedSorting = 'POPULAR';
  resetBySortOrFilterNeeded: boolean = false; //the change of value marks to itemsShowCase child component that initial value needed (init, filter or sort)

  filteredGames: Game[] = [];
  displayedGames: Game[]= [];


  constructor(
    private gameService: GameService,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleService,
    private translate: TranslateService
  ) { }


  ngOnInit(): void {
      this.routeSubs = this.activatedRoute.params.subscribe(params => {
        this.chosenCategory = params['category'];

        if (this.chosenCategory){
          //setting page title
          this.titleTranslateSubs?.unsubscribe();
          this.titleTranslateSubs = this.translate.stream([`CATEGORIES.${this.chosenCategory.toUpperCase().replace("-", "")}`, 'CATEGORIES.PAGE_TITLE' ]).subscribe(data => {
            let translatedTitle = Object.values(data).join(" | ");
            this.titleService.setTitle(`Lobby / ${translatedTitle}`);
          })

          // Resetting filters on route change
          this.searchTerm = '';
          this.showProviderSelector = false;
          this.selectedSorting = 'POPULAR';
          this.providerFilter = {};

          this.gameSubs?.unsubscribe();
          this.gameSubs = this.gameService.getGames().subscribe(games => {
            /** if games is empty(server error after log in and no LS) - all is set to zero/this section removes everything
            //no games at all -> randomGamesForCarousel will be []
            //no games in that category -> this.games will be [] (+anything else related to it)*/  //todo write a nice not found message like selected game

            //set 'all games' carousel
            this.randomGamesForCarousel = this.gameService.pickRandomGames(games.all, 16);

            //games in this category
            this.games = Games.fromGameArray(games.getGamesOfCategory(this.chosenCategory!))
            // console.log(this.games)

            //set providers for filtering (publishers having games in this category)
            this.providersInChosenCategory = this.games.byPublishers()
            // console.log(this.providersInChosenCategory)
            for (const publisher of this.providersInChosenCategory) {
              this.providerFilter[publisher.routerLink] = false;
            }

            this.loadItems(undefined);

          })

        }

      });

  }

  onSearchChange(searchTerm: string) {
    this.searchTerm = searchTerm;
    this.loadItems(undefined)
  }

  loadItems(itemsToShow: number | undefined) {
    //when itemsToShow is undefined, loadItems is called from parent, so initial itemsToShow value needed
    if (!itemsToShow){
      itemsToShow = this.itemsPerPage
    }
    if (itemsToShow === this.itemsPerPage){
      this.resetBySortOrFilterNeeded = !this.resetBySortOrFilterNeeded;
    }

    this.filterGames();
    // console.log(this.filteredGames)

    this.displayedGames = Games.fromGameArray(this.filteredGames).sortBy(this.selectedSorting).slice(0,itemsToShow)

  }

  filterGames() {
    //filter by searchTerm, if any
    if (!this.searchTerm || this.searchTerm.trim() === '') {
      // this.filteredGames = this.games?.all ?? [];
      this.filteredGames = this.games?.getMostPlayed() ?? [];
    } else {
      this.filteredGames = this.games?.getMostPlayed().filter(game => game.name.toLowerCase().includes((this.searchTerm).toLowerCase())) ?? []
    }

    //filter by selected providers, if any
    let selectedProviders = Object.keys(this.providerFilter).filter(provider => this.providerFilter[provider]);
    this.numOfSelectedProviders = selectedProviders.length;
    if (selectedProviders.length > 0) {
      this.filteredGames = this.filteredGames.filter(game =>
        selectedProviders.some(provider => game.publisher.replaceAll(" ",'-').toLowerCase().includes(provider))
      );
    }

  }

  sortOptionSelected(value: string){
    this.selectedSorting = value;
    this.loadItems(undefined)
  }


  toggleProviderSelector(): void {
    this.showProviderSelector = !this.showProviderSelector;
  }

  ngOnDestroy() {
    this.gameSubs?.unsubscribe();
    this.routeSubs?.unsubscribe();
    this.titleTranslateSubs?.unsubscribe();
  }

  //use placeholder when the image is not found
  updateNotFoundImgUrl(event: Event) {
    (event.target as HTMLImageElement).src = this.generateProviderSvgPlaceholderUrl((event.target as HTMLImageElement).alt.replace(" logo", ""));
  }

  generateProviderSvgPlaceholderUrl(text: string): string {
    const svg = `
    <svg width="300" height="150" xmlns="http://www.w3.org/2000/svg">
      <foreignObject width="100%" height="100%">
        <div xmlns="http://www.w3.org/1999/xhtml" style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center;color:#fff;font-size:50px;font-weight:bold;line-height:1.2;font-family:sans-serif;">${text}</div>
      </foreignObject>
    </svg>
  `;
    return `data:image/svg+xml;base64,${btoa(svg)}`;
  }


}
